import { moduleKey } from './../../../../core/constants/constants';
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation, effect } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { Navigation } from 'app/core/navigation/navigation.types';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { SessionExpiredService } from 'app/core/services/session_expired/session_expired.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { SearchService } from 'app/core/services/search/search.service';
import lgVideo from 'lightgallery/plugins/video';
import { LightGallery } from 'lightgallery/lightgallery';
import { BadgeOptions } from 'app/components/badge/badge.interface';
import { ModuleIcon } from 'app/interfaces/module-icon.interface';
import { ZuperDrawerService } from '@zuper/components/zuper-drawer';
import { ZuperNavigationItem, ZuperNavigationService, ZuperVerticalNavigationComponent } from '@zuper/components/zuper-navigation';
import { SettingsService } from 'app/core/services/settings/settings.service';
import { environment } from 'environments/environment';
import { AuthService } from 'app/core/auth/auth.service';
import { SearchWidgetComponent } from 'app/layout/common/search/search.component';
import { CreateWidgetComponent } from 'app/modules/dashboard/create-widget/create-widget.component';
import { BroadcastService } from 'app/layout/common/broadcast/broadcast.service';
import { TimezoneChangedPopupComponent } from 'app/components/timezone-changed-popup/timezone-changed-popup.component';
import { TimezonePickerService } from 'app/core/services/timezone/timezone-picker.service';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'thin-layout',
    templateUrl: './thin.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: [
      trigger('slideDownUp', [
        transition(':enter', [
          style({ transform: 'translateY(-10px)', opacity: 0 }),
          animate('150ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
        ]),
        transition(':leave', [
          animate('150ms ease-in', style({ transform: 'translateY(-10px)', opacity: 0 }))
        ])
      ])
    ]
})
export class ThinLayoutComponent implements OnInit, OnDestroy, AfterViewInit {
    search: any = '';
    showModel: boolean = false;
    showNav: boolean = false;
    navigation: Navigation;
    setSearchKeywordField: Subscription;
    zuperNavigation: Subscription;
    localNavigation: Subscription;
    myBroadcast: Array<any>;
    broadcastCount: number;
    lightGallery: LightGallery;
    allImages: Array<any> = [];
    company: any = {};
    lightningSearch: boolean = false;
    
    companyLogo: string = '';
    lightGallerySettings = {
        addClass: 'broadcast-light-gallery',
        counter: true,
        dynamic: true,
        licenseKey: environment.lightGalleryKey,
        dynamicEl: this.allImages,
        loop: false,
        videojs: true,
        hideControlOnEnd: true,
        slideEndAnimation: false,
        download: false,
        plugins: [lgVideo]
    };
    showSearchSuggestion = false;
    previouslySearchedValues = this._localStorageService.getLocalStorage('search_suggestions') || [];
     companyPolicy: any = this._utilityService.companyPolicy;
    companyConfig: any;
    userPreferredTimezone: string;
    newButtonData = [{
        displayName: 'job',
        displayKey: 'job',
        moduleName: 'JOB',
        permissionKey: 'job.new',
        path: '/jobs/new',
    }, {
        displayName: 'customer',
        displayKey: 'customer',
        moduleName: 'CUSTOMER',
        permissionKey: 'customer.new',
        path: '/customers/new',
    }, {
        displayName: 'quote',
        displayKey: 'quote',
        moduleName: 'ESTIMATES',
        permissionKey: 'estimate.new',
        path: '/estimates/new',

    }, {
        displayName: 'invoice',
        displayKey: 'invoice',
        moduleName: 'INVOICE',
        permissionKey: 'invoice.new',
        path: '/invoices/new',

    },
    //  {
    //     displayName: 'employee',
    //     displayKey: "user.text",
    //     moduleName: 'USER',
    //     permissionKey: 'user.new',
    //     path: '/employees/new',
    // },
    {
        displayName: 'broadcast',
        displayKey: 'broadcast.text',
        moduleName: 'BROADCAST',
        permissionKey: 'broadcast.new',
        path: '/settings/broadcast/new',
    }];
    showTimezoneBadge: boolean = false;
    showTimezoneBadgeSignal = this.timezonePickerService.showTimezoneBadge;
    private _unsubscribeAll: Subject<void> = new Subject<void>();

    /**
     * Constructor
     */
    constructor(
        private _router: Router,
        private _navigationService: NavigationService,
        private _zuperNavigationService: ZuperNavigationService,
        private sessionExpiredService: SessionExpiredService,
        public _utilityService: UtilityService,
        private _localStorageService: LocalStorageService,
        private searchService: SearchService,
        private _zuperDrawerService: ZuperDrawerService,
        private _settingsService: SettingsService,
        private auth: AuthService,
        private broadcastService: BroadcastService,
        private zuperDialogService: ZuperDialogService,
        private timezonePickerService: TimezonePickerService,
    ) {
        this.sessionExpiredService.isSessionExpired.next(false);
        effect(() => {
            this.showNav = ['false', false].includes(this._utilityService.settingsActiveConfig()?.settingsActive) || !this._router.url?.toLocaleLowerCase()?.includes('settings_new');
            const timezoneBadgeSignalValue = this.showTimezoneBadgeSignal();
            this.showTimezoneBadge = timezoneBadgeSignalValue;
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): any {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.userPreferredTimezone = this._localStorageService.getLocalStorage('user_preferences')?.timezone;
        this.companyConfig = this._localStorageService.getLocalStorage('company_configuration_data');
        this.companyPolicy = this._localStorageService.getLocalStorage('company_policy');
        const settingsActiveConfig: any =  this._localStorageService.getLocalStorage('settings_active_config');
        this.showTimezoneBadge = JSON.parse(this._localStorageService.getLocalStorage('has_timezone_difference')) ?? false;
        const currentUrl = this._router.url;
        let isSettingsActive = currentUrl?.toLocaleLowerCase()?.includes('settings_new') || settingsActiveConfig?.settingsActive;
        
        this._utilityService.companyLogo.subscribe((logo: any) => {
            this.companyLogo = logo
        });
        
        const isFinanceEnabledInPolicy: boolean = this.companyPolicy?.financing_enabled ;
        const isFinanceEnabledInConfig: boolean =  this.companyConfig?.financing?.is_enabled;
        this.zuperNavigation = this._zuperNavigationService.navToggler.subscribe((val) => {
            this.showNav = val;
        });
        // Subscribe to navigation data
        this.localNavigation = this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) => {
                const navigationResult = {
                    compact: [],
                    default: [],
                    futuristic: [],
                    horizontal: [],
                };
                navigation?.compact?.forEach((navigator) => {
                    if (navigator?.type === 'basic' && navigator.moduleKey) {
                        
                        if(this.auth.isModuleAccessableForC2A(navigator)){
                            if(navigator?.id === 'zuper-connect' && this._localStorageService.getLocalStorage('is_zuper_agent')){
                                navigator['hidden'] = false;
                            }
                            navigationResult.compact.push(navigator);
                        }
                    } else if (navigator?.type === 'aside') {
                        const accessibleModules = [];
                        navigator?.children.forEach((module: any) => {
                            if(this.auth.isModuleAccessableForC2A(module)){
                                accessibleModules.push(module);
                            }
                        });
                        const reportModule = accessibleModules.find(module => module?.moduleKey === 'REPORTS');
                        const advancedReportModule = accessibleModules.find(module => module?.moduleKey === 'ADVANCED_REPORTS');
                        if (reportModule && advancedReportModule) {
                          reportModule.title = 'Legacy Reports';
                          reportModule.localeKey = 'text.legacy_reports';
                        }
                        const customerModule = accessibleModules.find(module => module?.moduleKey === 'CUSTOMER');
                        if (customerModule && this._utilityService.isCompanyB2BEnabled()) {
                          customerModule.title = 'Contacts';
                        }
                        if (accessibleModules.length > 1) {
                            navigator.children = accessibleModules;
                            navigationResult.compact.push(navigator);
                        }else if(accessibleModules?.length === 1){
                          navigator = accessibleModules[0];
                          navigator.tooltip = accessibleModules[0].title;
                          delete navigator.children;
                          navigationResult.compact.push(navigator);
                        }
                    } else if ((navigator?.type === 'basic') && navigator.moduleKey === '') {
                        if(!(navigator?.title === 'Workflows' && !this.companyPolicy?.workflows?.is_enabled) && navigator?.title !== 'Settings'){
                            navigationResult.compact.push(navigator);
                        }
                        else if(navigator?.title === 'Settings')
                        {
                            navigator.link = settingsActiveConfig?.newSettingsActive ? '/settings_new' : '/settings';
                            navigationResult.compact.push(navigator);
                        }
                    }
                });
                this.navigation = navigationResult;
                if(!isSettingsActive){
                  this._zuperNavigationService.navToggler.next(true);
                }
                this.searchService.accessibleModules.next(navigationResult);
            });

        this.sessionExpiredService.isSessionExpired.subscribe((response: any) => {
            this.showModel = response;
        });

        this.setSearchKeywordField = this.searchService.setSearchKeywordField.subscribe((data: string) => {
            this.search = this.searchService.getSearchKeyValue(data) ?? '';
        });
        this.company = this._localStorageService.getLocalStorage('company');
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        this.sessionExpiredService.isSessionExpired.next(false);
        this.setSearchKeywordField.unsubscribe();
        this.zuperNavigation.unsubscribe();
        this.localNavigation.unsubscribe();
        this.search = '';
    }

    ngAfterViewInit(): void {
        this.getButtonData();
    }

    getButtonData(): any{
        this.newButtonData.forEach((data) => {
            if (data.moduleName === 'BROADCAST') {
                data['hasModuleAccess'] = true;
                data['hasPermission'] = true;
            } else {
                data['hasModuleAccess'] = this._utilityService.hasModuleAccess(data?.moduleName);
                data['hasPermission'] = this._utilityService.hasPermission(data?.permissionKey);
            }
        });
    }

    redirectTo(data): any{
        if (data.moduleName === 'BROADCAST') {
            if(!this._utilityService.settingsActiveConfig()?.newSettingsActive)
                this._localStorageService.setLocalStorage('CurrentSettingsPage',data.path);

            this._router.navigate([this._utilityService.settingsActiveConfig()?.newSettingsActive ? '/settings_new/misc/broadcast' : '/settings/broadcast/new'], { state: { data: data } });
           
            const currentRoute = window.location.href;
            if(!this._utilityService?.isEmptyOrUndefined(currentRoute) && (currentRoute?.includes('settings') || currentRoute?.includes('dispatch'))){
                this._settingsService.redirectSettings.next(true);
            }
        }else{
            this._router.navigateByUrl(data.path);
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
        const navigation = this._zuperNavigationService.getComponent<ZuperVerticalNavigationComponent>(name);

        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    redirectToSearchModule(): void {
        this.search = this.searchService.getSearchKeyValue(this.search);
        this._localStorageService.setLocalStorage('search_page_keyword', this.search);
        this.searchService.searchKeywordChanged.next(this.search);
        this._router.navigate(['/search']
            // ,{ queryParams: {'keyword': this.search}}
        );
    }

    //Broadcast
    openBroadcastDrawer(event): void {
        this.myBroadcast = event.data;
        this.myBroadcast.sort((a, b) => {
            return b?.broadcast_type?.sticky - a?.broadcast_type?.sticky;
        });
        this.broadcastCount = event.count;
        this.toggleDrawer('openBroadcastMessages');
    }

    lightOnInit = (detail: any): void => {
        this.lightGallery = detail.instance;
    };

    openLightGallery(rowData): void {
        this.allImages = [{
            'src': rowData.broadcast_image,
            'name': `${rowData?.created_by?.first_name} ${rowData?.created_by?.last_name}`
        }];
        this.lightGallery.refresh(this.allImages);
        this.lightGallery.openGallery();
    }

    toggleDrawer(drawerName): void {
        const drawer = this._zuperDrawerService.getComponent(drawerName);
        drawer.toggle();
    }

    setListCount(): BadgeOptions {
        const badgeOption: BadgeOptions = {
            type: 'PRIMARY',
            displayName: this.broadcastCount ?? 0,
            displayType: 'listingCount'
        };
        return badgeOption;
    }

    openSearchSuggestions(): void {
        this.previouslySearchedValues = this._localStorageService.getLocalStorage('search_suggestions') || [];
        if (this.previouslySearchedValues.length > 0) {
            this.showSearchSuggestion = true;
        }
    }

    getIconClass(module: string): string {
        return ModuleIcon[module];
    }

    getRouterLink(searchObj: any): any {
        if (searchObj) {
            const hasAccess = this.getHasAccess(searchObj);
            if (hasAccess) {
                return this._utilityService.getLink(searchObj.module, searchObj.uid);
            } else {
                return [];
            }
        }
    }

    getHasAccess(search): boolean {
        let hasAccess = true;
        if ((moduleKey[search.module] === 'PROPERTY') || (moduleKey[search.module] === 'ORGANIZATION')) {
            hasAccess = this._utilityService.hasModuleAccess(moduleKey[search.module], true, 'from_sidebar');
        }
        else {
            hasAccess = this._utilityService.hasModuleAccess(moduleKey[search.module], false, 'from_sidebar');
        }
        return hasAccess;
    }

    clearRecentActivity(): void {
        this._localStorageService.removeLocalStorage('search_suggestions');
        this.showSearchSuggestion = false;
    }

    openSearch(): void {
        const dialogRef = this.zuperDialogService.openCustom(SearchWidgetComponent,
          {
            extraClass: 'search-widget',
            dismissible: true,
            data: {
              
            }
        });
    }

    getBroadcastMessages(event: any): void{
        if(event.openDrawer)
        {
            this.broadcastService.getBroadcastMessages().then((brodcastData: any) => {
                this.openBroadcastDrawer({data:brodcastData || [], count: brodcastData?.length || 0});
            })
        }
    }

    showTimezoneDialog(): void {
      this.zuperDialogService.openCustom(TimezoneChangedPopupComponent).afterClosed().subscribe((result)=>{
        if(result){
          this.showTimezoneBadge = false;
        }
      });
    }
}
